const GlobeIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 14.666A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.333zM1.334 8h13.333"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 1.333A10.2 10.2 0 0110.668 8a10.2 10.2 0 01-2.666 6.666A10.2 10.2 0 015.334 8a10.2 10.2 0 012.667-6.667v0z"
    ></path>
  </svg>
);

export default GlobeIcon;
